import * as React from "react";
import { SVGProps } from "react";

const Feathercoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505 505" {...props}>
    <circle
      cx={253}
      cy={253}
      r={241.9}
      fill="none"
      stroke="#384a53"
      strokeLinejoin="bevel"
      strokeWidth={22.129}
    />
    <path
      fill="#384a53"
      d="M121.651 416.39s34.458-34.458 16.755-45.207c-4.426-9.167-8.852-1.58-13.277 14.858-2.53 10.749-4.742-20.232 1.896-22.445 6.323-2.529-22.129-27.82-27.819-30.032-6.007-2.53 6.323-8.22 22.13 6.639 15.49 14.858 15.173 18.967 17.07 16.754 1.897-2.212.632-10.116-2.213-13.593-2.845-3.478-15.806-31.297-13.91-30.665 1.897.633 19.917 20.549 24.975 33.826 5.374 12.961 5.058-24.658 5.058-24.658s4.11-15.174 6.006-19.6 5.69 10.116 5.69 10.116 2.846 17.703 11.381 24.026 6.323-8.536 6.323-8.536l-3.161-71.129 14.858-13.277s-1.581 55.955 7.27 52.793 10.433-27.819 10.433-27.819 6.006-40.148 5.69-42.361 7.587-6.64 7.587-6.64l19.917-18.019s-.633 19.917 7.587 24.026c8.22 4.426 8.535-20.548 8.535-20.548l2.845-24.342s108.117-86.936 129.93-91.994c18.968 19.284 18.652 51.213 10.748 60.697-7.587 9.484-77.768 104.007-77.768 104.007s-30.98-2.213-34.774 6.639c-3.794 8.851 25.923 6.638 25.923 6.638l-49 65.123c-34.143-13.594-81.246 10.116-86.62 18.652 0 0-3.794 5.374 7.587 6.006 11.38.632 92.31 1.265 92.31 1.265l-33.194 8.851s-64.49-.632-70.18-3.793-2.213 5.374-2.213 5.374 11.38 19.916 34.142 24.974c22.76 5.058-22.762-2.529-22.762-2.529s-18.02-4.426-23.077-18.335c-5.058-13.594-6.007 3.793-6.007 3.793s9.168 21.181 24.975 25.607c15.49 4.426-9.168.316-9.168.316s-21.18-8.22-23.078-13.594c-1.897-5.374-5.374 6.007-5.374 6.007s-18.652 22.761-23.71 23.393c-5.058.633-.316-1.264-.316-1.264z"
    />
    <path
      fill="#fff"
      d="M228.187 287.409s105.271-127.717 142.258-153.64c1.581-.948 1.265.95 1.265.95s-69.865 90.728-139.73 153.638c-7.903 7.271-3.793-.948-3.793-.948z"
    />
  </svg>
);

export default Feathercoin;
